import React from 'react'

const CoverageDetails = () => {
  return (
    <div>
      CoverageDetails
    </div>
  )
}

export default CoverageDetails
